module.exports = "<div class=\"message-container\">\n    <h2>The site is under maintenance.</h2>\n    <p>We're sorry for the inconvenience.</p>\n</div>\n"